import axios from 'axios'
import { AppUrl } from '@/assets/js/variables'

const state = {
  chartStatus: {
    loading: false,
    noData: false
  },
  brands: [],
  chartOptions: {
    plotOptions: {
      bar: {
        horizontal: false,
        endingShape: 'rounded',
        columnWidth: '5'
      }
    },
    chart: {
      id: 'competitors-chart',
      toolbar: {
        show: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      }
    },
    dataLabels: {
      enabled: false
    },
    grid: {
      curve: 'smooth',
      lineCap: 'butt',
      color: '#000',
      strokeDashArray: 3
    },
    fill: {
      colors: '#307fff',
      type: 'gradient',
      gradient: {
        shade: 'light',
        type: 'vertical',
        colorFrom: '#D8E3F0',
        colorTo: '#BED1E6',
        shadeIntensity: 0.2,
        inverseColors: true,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 100]
      }
    },
    xaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      },
      categories: []
    },
    yaxis: {
      max: 100,
      min: 0,
      labels: {
        show: true,
        formatter: (value) => { return value }
      },
      axisBorder: {
        show: false
      }
    },
    series: []
  }
}

const getters = {
  getCat: (state) => {
    return state.categories
  }
}

let elemRef = null
let elemRefPopup = null

const actions = {
  getChart ({ commit }, filter) {
    commit('SET_loading', true)
    return new Promise((resolve, reject) => {
      if (filter.elemRef && filter.elemRefPopup) {
        elemRef = filter.elemRef
        elemRefPopup = filter.elemRefPopup
      }
      axios.post(AppUrl, {
        task: 'loadModule',
        payload: {
          brand_ids: filter.brandId,
          seller_ids: filter.sellerId,
          category_ids: filter.categoryId,
          module_id: 1
        }
      })
        .then(response => {
          if (response.data.payload.categories.length > 0) {
            console.log('Competitors Coverage Chart Load', response.data.payload)
            commit('SET_ChartOptions', {categories: response.data.payload.categories, series: response.data.payload.series})
            commit('SET_noData', false)
            resolve()
          } else {
            commit('SET_noData', true)
            resolve()
          }
          commit('SET_loading', false)
        })
        .catch(error => {
          commit('SET_loading', false)
          commit('SET_noData', true)
          resolve()
          console.log(error)
        })
    })
  },
  getCategories ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getCategory',
        payload: {
          category_name: filter.categoryName,
          brand_id: filter.brandId,
          module_id: 1
        }
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_categories', response.data.payload.category)
          }
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getBrands ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getBrand',
        payload: {brand_name: filter.brandName, category_id: filter.categoryId, module_id: 1}
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_brands', response.data.payload.brand)
          }
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  }
}

const mutations = {
  SET_loading (state, boolean) {
    state.chartStatus.loading = boolean
  },
  SET_noData (state, bool) {
    state.chartStatus.noData = bool
  },
  SET_categories (state, data) {
    state.categories = data
  },
  SET_brands (state, data) {
    state.brands = data
  },
  SET_ChartOptions (state, filter) {
    state.chartOptions.xaxis.categories = filter.categories
    state.chartOptions.series = []
    state.chartOptions.series.push(filter.series)
    if (elemRef && elemRefPopup) {
      elemRef.refresh()
      elemRefPopup.refresh()
    }
  },
  SET_columnWidth (state, filter) {
    state.chartOptions.plotOptions.bar.columnWidth = filter.width
  },
  RESET_columnWidth (state) {
    state.chartOptions.plotOptions.bar.columnWidth = '3'
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/analytics/competitorscoverage.js